import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  StudentGroup,
  StudentGroupMember,
  CreateStudentGroupRequest,
  UpdateStudentGroupRequest,
  AddGroupMembersDto,
} from '../../interfaces/student-group';
import {
  ApiCollectionResponse,
  ApiSimpleResponse,
  ApiSingleResponse,
} from '../../interfaces/responses/api-response';

/** Admin-side endpoints — full CRUD + members management. */
@Injectable({ providedIn: 'root' })
export class AdminStudentGroupService {
  private readonly base = `${environment.BASE_URL}/admin/student-groups`;

  constructor(private http: HttpClient) {}

  list(): Observable<ApiCollectionResponse<StudentGroup>> {
    return this.http.get<ApiCollectionResponse<StudentGroup>>(this.base);
  }

  getById(id: number): Observable<ApiSingleResponse<StudentGroup>> {
    return this.http.get<ApiSingleResponse<StudentGroup>>(`${this.base}/${id}`);
  }

  create(
    payload: CreateStudentGroupRequest,
  ): Observable<ApiSingleResponse<StudentGroup>> {
    return this.http.post<ApiSingleResponse<StudentGroup>>(this.base, payload);
  }

  update(
    id: number,
    payload: UpdateStudentGroupRequest,
  ): Observable<ApiSingleResponse<StudentGroup>> {
    return this.http.put<ApiSingleResponse<StudentGroup>>(
      `${this.base}/${id}`,
      payload,
    );
  }

  delete(id: number): Observable<ApiSimpleResponse> {
    return this.http.delete<ApiSimpleResponse>(`${this.base}/${id}`);
  }

  addMembers(
    groupId: number,
    payload: AddGroupMembersDto,
  ): Observable<ApiCollectionResponse<StudentGroupMember>> {
    return this.http.post<ApiCollectionResponse<StudentGroupMember>>(
      `${this.base}/${groupId}/members`,
      payload,
    );
  }

  removeMember(groupId: number, studentId: number): Observable<ApiSimpleResponse> {
    return this.http.delete<ApiSimpleResponse>(
      `${this.base}/${groupId}/members/${studentId}`,
    );
  }

  byLevel(
    learningPathId: number,
  ): Observable<ApiCollectionResponse<StudentGroup>> {
    return this.http.get<ApiCollectionResponse<StudentGroup>>(
      `${this.base}/by-level/${learningPathId}`,
    );
  }

  byProfessor(
    professorId: number,
  ): Observable<ApiCollectionResponse<StudentGroup>> {
    return this.http.get<ApiCollectionResponse<StudentGroup>>(
      `${this.base}/by-professor/${professorId}`,
    );
  }
}
